import { AppState } from "@pmis3/data-access";
import { VesselVisitState, VesselVisitStateStatus } from "../reducers/vesselVisit.reducer";
import { createSelector } from "@ngrx/store";
import { VesselVisitStepperHelper } from "../../../../../vessel-visit/src/lib/pmis3-vessel-visit/vessel-visit-stepper/vesselVisitStepper.helper";

export const vesselVisitState = (state: AppState) => state.vesselVisitState;

// export const selectInitialVesselVisits = createSelector(
//     vesselVisitState,
//     (state: VesselVisitState) => {
//         console.log("state: ", state)
//         return state.status === VesselVisitStateStatus.SUCCESS ? state.initialVesselVisits?.items : [];
//     }
// )

export const selectVesselVisitStateStatus = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.status
)

export const selectVesselVisits = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => {
        console.log("state: ", state)
        return state.vesselVisits;
    }
)

export const selectSelectedVesselVisit = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.selectedVesselVisit
)

export const selectSelectedVesselActivitiesIndices = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.selectedVesselActivitiesIndices
)

export const selectEditingVesselActivities = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.editingVesselActivities
)

export const selectVesselActivityPurposes = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.purposes
)

export const selectLadenStatuses = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.ladenStatuses
)

export const selectLocationsForNOA = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.locations
)

export const selectTerminalsForNOA = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.terminals
)

export const selectOrganizations = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.organizations
)

export const selectOrganizationTypes = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => {
        return state.organizationTypes
    }
)

export const selectVessels = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.vessels 
)

export const selectVesselOrientation = createSelector(
  vesselVisitState,
  (state: VesselVisitState) => state.vesselOrientations
)

export const selectServiceApplicationTypes = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.serviceApplicationTypes
)

export const selectAgentOrganization = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.agentOrganization
)

export const selectCargoTypes = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.cargoTypes
)

export const selectCargoUnitTypes = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.cargoUnitTypes
)

export const selectTransitStatuses = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.transitStatuses
)

export const selectVesselVisitIsDirty = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.vesselVisitIsDirty 
)

// export const selectPilotStations = createSelector(
//     vesselVisitState,
//     (state: VesselVisitState) => state.pilotStations
// )

export const selectCargoOperations = createSelector(
    vesselVisitState,
    (state: VesselVisitState) => state.cargoOperations
)

export const selectVesselActivitiesWithProgress = createSelector(
  (state: AppState) => state.vesselVisitState,
  (visitState) => {
    const activities = visitState?.vesselActivities ?? [];
    console.log('Calculating progress for activities: ', activities);
    return VesselVisitStepperHelper.calculateProgressForActivities(activities);
  }
);
